import axiosIns from '@/libs/axios'
import toErrorResult from '@/store/helpers/errorResult'

const ROOT_URL = '/Admin/data/services'

// Arşivle / geri yükle: sonucu döndürür, dataSave'e yazmaz (sonucu çağıran ekran gösterir)
const setArchived = (action, id) => axiosIns
  .post(`${ROOT_URL}/${action}`, { id })
  .then(response => response.data)
  .catch(error => toErrorResult(error))
export default {
  namespaced: true,
  state: {
    loading: false,
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      scode: null,
      title: null,
      description: null,
      notes: null,
      urls: [],
      id_departments: null,
      id_service_categories: null,
      id_teams: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    checkCodeResult: {
      message: null,
      status: true,
    },
    filterParams: {
      id_service_categories: null,
      keywords: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    checkCodeResult(state) {
      return state.checkCodeResult
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_CHECK_CODE_RESULT(state, data) {
      state.checkCodeResult = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        scode: null,
        title: null,
        description: null,
        notes: null,
        urls: [],
        id_departments: null,
        id_service_categories: null,
        id_teams: null,
        id_users: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'services.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          // Arşivdeki kayıt normal sorguda dönmez; bulunamazsa arşivde ara (yetkisizse backend boş döner)
          .then(response => (response.data.data ? response : axiosIns.post(ROOT_URL, { ...data, archived: true })))
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      commit('SET_LOADING', true)
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    archiveData(context, id) {
      return setArchived('archiveData', id)
    },
    restoreData(context, id) {
      return setArchived('restoreData', id)
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data.status
        })
        .catch(error => console.error(error))
    },
    async checkCode({ commit }, postData) {
      return axiosIns
        .post(`${ROOT_URL}/checkCode`, postData)
        .then(response => {
          commit('SET_CHECK_CODE_RESULT', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
